import { CSSProperties } from "react";
import { styles } from "./Image.style";

export interface ImageProps {
  image?: IImage;
  loadEagerly?: boolean;
  srcSizes?: number[];
  defaultSrcSize?: number;
  sizes?: string;
  fetchPriorityHigh?: boolean;
}
interface IImage {
  url: string;
  width?: number;
  height?: number;
  title?: string;
  altText?: string;
}

export const calcAspectForImage = (image: IImage | undefined): string => {
  return image?.width && image?.height ? Number(image.width / image.height).toPrecision(3) : "auto";
};

export const Image = (props: ImageProps) => {
  const {
    image,
    srcSizes = [200, 400, 800, 1024],
    defaultSrcSize = 1200,
    sizes,
    loadEagerly = false,
    fetchPriorityHigh = false,
  } = props;

  const aspect = calcAspectForImage(image);

  let srcSet = "";
  let srcSetAvif = "";
  let srcSetWebp = "";

  if (image && image.url) {
    srcSetAvif = `${image.url}?fm=avif ${defaultSrcSize}w,`;

    if (srcSizes && srcSizes.length > 0) {
      srcSet = srcSet + " " + srcSizes.map((size) => `${image.url}?fm=png&w=${size} ${size}w`).join(", ");
      srcSetAvif = srcSetAvif + " " + srcSizes.map((size) => `${image.url}?fm=avif&w=${size} ${size}w`).join(", ");
      srcSetWebp = srcSetWebp + " " + srcSizes.map((size) => `${image.url}?fm=webp&w=${size} ${size}w`).join(", ");
    }
  }

  return (
    <div
      className={styles.root()}
      style={image?.width ? ({ "--maxWidth": `${image.width}px` } as CSSProperties) : undefined}
    >
      <div>
        {image && image.url && (
          <picture>
            <source type="image/avif" srcSet={`${srcSetAvif}`} sizes={sizes} />
            <source type="image/webp" srcSet={`${srcSetWebp}`} sizes={sizes} />
            <source type="image/png" srcSet={`${srcSet}`} sizes={sizes} />
            <img
              alt={image.altText ?? image.title ?? ""}
              title={image.title}
              className={styles.image()}
              style={{ "--aspectRatio": aspect } as CSSProperties}
              src={image.url}
              fetchPriority={fetchPriorityHigh ? "high" : "auto"}
              loading={loadEagerly ? "eager" : "lazy"}
              decoding={loadEagerly ? "sync" : "async"}
            />
          </picture>
        )}
      </div>
    </div>
  );
};
